module.exports = __webpack_public_path__ + "static/media/train13-1.d67b328f.png";